import { action, observable, runInAction } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import serviceCardController from './controller';
import {
  CardType,
  CreateCardTypeRequest,
  UpdateCardTypeRequest,
  DeleteAndRestoreCardTypeRequest,
  CardTypePosition,
  GetCardTypePositionsRequest,
  CreateCardTypePositionRequest,
  UpdateCardTypePositionRequest,
  DeleteAndRestoreCardTypePositionRequest,
} from '../api/cardReference';

export interface CardReferenceStore {
  cardTypes: CardType[],
  error: ErrorInterface,
  currentCardType: CardType,
  cardTypePositions: CardTypePosition[],
  cardTypePositionByRequest: GetCardTypePositionsRequest,
  currentCardTypePosition: CardTypePosition,
}

export const cardReferenceStore: CardReferenceStore = observable({
  cardTypes: [],
  error: null,
  currentCardType: null,
  cardTypePositions: [],
  cardTypePositionByRequest: null,
} as CardReferenceStore);

export const cardReferenceActions = {

  getServiceCardsTypes: async (showDeleted = false): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.getServiceCardsTypes(showDeleted);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      cardReferenceStore.cardTypes = response.data;
    });
  },

  getServiceCardType: async (id: string): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.getServiceCardType(id);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      // cardReferenceStore.currentCardType = response.data;
    });
  },

  createServiceCardType: async (request: CreateCardTypeRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.createServiceCardType(request);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        cardReferenceStore.cardTypes.push(response.data);
      }
    });
  },

  updateServiceCardType: async (request: UpdateCardTypeRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.updateServiceCardType(request);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        cardReferenceStore.cardTypes = cardReferenceStore.cardTypes
          .map((v) => (v.id === response.data.id
            ? { ...response.data }
            : { ...v }));
      }
    });
  },

  deleteServiceCardType: async (request: DeleteAndRestoreCardTypeRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.deleteServiceCardType(request);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        cardReferenceStore.cardTypes
          .find((v) => v.id === request.id).deletedDate = 'deleted';
      }
    });
  },

  restoreServiceCardType: async (request: DeleteAndRestoreCardTypeRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.restoreServiceCardType(request);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        cardReferenceStore.cardTypes = cardReferenceStore.cardTypes
          .map((v) => (v.id === response.data.id
            ? { ...response.data }
            : { ...v }));
      }
    });
  },

  setCurrentCardType: async (data: CardType): Promise<void> => {
    cardReferenceActions.clearError();
    if (cardReferenceStore?.currentCardType?.id !== data?.id) { cardReferenceActions.clearCardTypePositions(); }
    runInAction(() => {
      cardReferenceStore.currentCardType = data;
    });
  },

  clearCurrentCardType: async (): Promise<void> => {
    cardReferenceActions.clearError();
    runInAction(() => {
      cardReferenceStore.currentCardType = null;
    });
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      cardReferenceStore.error = errorData;
      throw errorData;
    }
  }),

  clearCardTypes: action(() => {
    cardReferenceStore.cardTypes = [];
  }),

  clearError: action(() => {
    cardReferenceStore.error = null;
  }),

  getServiceCardTypePositions: async (data: GetCardTypePositionsRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.getServiceCardTypePositions(data);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      cardReferenceStore.cardTypePositions = response.data
        .map((v) => { return { ...v, freeCount: v.freeCount === -1 ? 0 : v.freeCount }; });
      cardReferenceStore.cardTypePositionByRequest = data;
    });
  },

  setCurrentCardTypePosition: async (data: CardTypePosition): Promise<void> => {
    cardReferenceActions.clearError();
    // if (cardReferenceStore?.currentCardType?.id !== data?.id) { cardReferenceActions.clearCardTypePositions(); }
    runInAction(() => {
      cardReferenceStore.currentCardTypePosition = data;
    });
  },

  createServiceCardTypePosition: async (request: CreateCardTypePositionRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController
      .createServiceCardTypePosition({ ...request, freeCount: request.freeCount === 0 ? -1 : request.freeCount });
    cardReferenceActions.handleError(response);
    /*  runInAction(() => {
      if (!response.errorData) {
        cardReferenceStore.cardTypePositions.push(response.data);
      }
    }); */
  },

  updateServiceCardTypePosition: async (request: UpdateCardTypePositionRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController
      .updateServiceCardTypePosition({ ...request, freeCount: request.freeCount === 0 ? -1 : request.freeCount });
    cardReferenceActions.handleError(response);
    /* runInAction(() => {
      if (!response.errorData) {
        cardReferenceStore.cardTypes = cardReferenceStore.cardTypes
          .map(v => (v.id === response.data.id
            ? { ...response.data }
            : { ...v }));
      }
    }); */
  },

  deleteServiceCardTypePosition: async (request: DeleteAndRestoreCardTypePositionRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.deleteServiceCardTypePosition(request);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        cardReferenceStore.cardTypePositions
          .find((v) => v.id === request.id).deletedDate = 'deleted';
      }
    });
  },

  restoreServiceCardTypePosition: async (request: DeleteAndRestoreCardTypePositionRequest): Promise<void> => {
    cardReferenceActions.clearError();
    const response = await serviceCardController.restoreServiceCardTypePosition(request);
    cardReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        cardReferenceStore.cardTypePositions = cardReferenceStore.cardTypePositions
          .map((v) => (v.id === response.data.id
            ? { ...response.data }
            : { ...v }));
      }
    });
  },

  clearCurrentCardTypePosition: async (): Promise<void> => {
    cardReferenceActions.clearError();
    runInAction(() => {
      cardReferenceStore.currentCardTypePosition = null;
    });
  },

  clearCardTypePositions: action(() => {
    cardReferenceStore.cardTypePositions = [];
    cardReferenceStore.cardTypePositionByRequest = null;
  }),
};
